export var OPT_OUT_EVENT = "RCB/OptOut";